import { render, staticRenderFns } from "./LivestockIndex.vue?vue&type=template&id=08b46feb&"
import script from "./LivestockIndex.vue?vue&type=script&lang=js&"
export * from "./LivestockIndex.vue?vue&type=script&lang=js&"
import style0 from "./LivestockIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports